import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), {}, {
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M22.5 15h-9.592c-.207-.581-.757-1-1.408-1h-1c-.827 0-1.5.673-1.5 1.5v8c0 .827.673 1.5 1.5 1.5h1c.651 0 1.201-.419 1.408-1H22.5a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5m-11 9h-1a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5M22 23h-9v-7h9v7"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15 18h1v1h-1zM15 20h1v1h-1zM17 18h1v1h-1zM17 20h1v1h-1zM19 18h1v1h-1zM19 20h1v1h-1zM12 9h8v5h1V8.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5V13h1V9"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14 11a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4"
      })]
    })
  }));
};
export default SvgComponent;